import {
  child, equalTo, get, getDatabase, orderByChild, push, query, ref,
  // onValue,
  remove, update
} from "firebase/database";
import { useLocalObservable } from "mobx-react-lite";
import StoreAction from "./StoreAction";
const initialState = {
  currentPlanIndex: 0,
};
const MilestoneStore = () => {
  const dbRef = ref(getDatabase());
  const db = getDatabase();
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
    async getcurChapter(uid) {
      let currentUser = (await get(child(dbRef, `users/${uid}`))).val();
      this.teamId = currentUser.teamId;
      const curChapter = await get(
        query(
          ref(db, "teams"),
          orderByChild("teamId"),
          equalTo(currentUser.teamId)
        )
      );
      return curChapter;
    },
  }));

  return store;
};

export default MilestoneStore;
